import React from "react";
import ChangePassword from "./ChangePassword";
import MfaQr from "./MfaQr";

const SecurityPage: React.FC = () => <div className="portal-security-controls">
    <ChangePassword />
    <div className="portal-security-divider" />
    <MfaQr />
</div>;

export default SecurityPage;
